<div>
    <ng-container *ngFor="let item of checklist">
        <ng-container>
            <ion-chip
                *ngIf="(item.status === 'Pending' && type === item.type) || (item.status === 'Pending' && requirementId === item.requirementid)"
                class="pending-chip status-chip"
                mode="ios"
                outline="true"
            >
                <fa-icon [icon]="faExclamationCircle"></fa-icon>
                <ion-label>Pending Review</ion-label>
            </ion-chip>
            <ion-chip
                *ngIf="(item.status === 'Accepted' && type === item.type) || (item.status === 'Accepted' && requirementId === item.requirementid)"
                class="accepted-chip status-chip"
                mode="ios"
                outline="true"
            >
                <fa-icon [icon]="faCheckCircle"></fa-icon>
                <ion-label>Accepted</ion-label>
            </ion-chip>
            <ion-chip
                *ngIf="(item.status === 'Rejected' && type === item.type) || (item.status === 'Rejected' && requirementId === item.requirementid)"
                class="rejected-chip status-chip"
                mode="ios"
                outline="true"
            >
                <fa-icon [icon]="faExclamationCircle"></fa-icon>

                <ion-label>Not Accepted</ion-label>
            </ion-chip>
        </ng-container>
    </ng-container>
</div>
